import { combineReducers } from "redux";

import { RootAction } from "../types";
import { Topic } from "dialup";

function data(
  state: { [k: string]: Topic } = {},
  action: RootAction
): { [k: string]: Topic } {
  switch (action.type) {
    case "LIST_TOPICS_SUCCESS":
      state = { ...state };

      action.payload.topics.forEach((t: Topic) => (state[t.id] = t));

      return state;
    case "CREATE_TOPIC_SUCCESS":
      state = { ...state };

      const { topic } = action.payload;
      state[topic.id] = topic;

      return state;

    default:
      return state;
  }
}

function list(state: string[] = [], action: RootAction): string[] {
  switch (action.type) {
    case "LIST_TOPICS_SUCCESS":
      return action.payload.topics.map((t: Topic) => t.id);

    case "CREATE_TOPIC_SUCCESS":
      const { topic } = action.payload;
      return [topic.id, ...state];

    default:
      return state;
  }
}

function uploadError(state: string = "", action: RootAction): string {
  switch (action.type) {
    case "CREATE_TOPIC_REQUEST":
    case "CREATE_TOPIC_SUCCESS":
      return "";
    case "CREATE_TOPIC_FAILURE":
      return action.payload.message;
    default:
      return state;
  }
}

function uploadLoading(state: boolean = false, action: RootAction): boolean {
  switch (action.type) {
    case "CREATE_TOPIC_REQUEST":
      return true;
    case "CREATE_TOPIC_SUCCESS":
    case "CREATE_TOPIC_FAILURE":
      return false;
    default:
      return state;
  }
}

export const callsReducer = combineReducers({
  data,
  list,
  uploadError,
  uploadLoading,
});
export default callsReducer;



// WEBPACK FOOTER //
// ./src/reducers/topicsReducer.ts